import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Footer = () => {
  const { user, profile } = useAuth();
  const location = useLocation();

  const getHomeLink = () => {
    if (!user) return '/matrimony';
    if (!profile || profile.profileStatus === 'Draft') return '/matrimony/complete-profile';
    if (profile.verificationStatus === 'Pending') return '/matrimony/verification-pending';
    return '/matrimony/dashboard';
  };

  const handleHomeClick = (e) => {
    if (location.pathname === '/matrimony' || (user && location.pathname === '/matrimony/dashboard')) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleSearchClick = (e) => {
    if (location.pathname === '/matrimony/search') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePlansClick = (e) => {
    if (!user && location.pathname === '/matrimony') {
      e.preventDefault();
      const el = document.getElementById('plans');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleStoriesClick = (e) => {
    if (location.pathname === '/matrimony') {
      e.preventDefault();
      const el = document.getElementById('stories');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="w-full border-t-2 border-primary-brand/20">
      <div
        className="w-full bg-white"
        style={{
          backgroundImage: "url('/images/img__1.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="w-full max-w-[1360px] mx-auto px-4 sm:px-6 py-12 sm:py-14 md:py-16">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <Link to={getHomeLink()} className="flex items-center gap-3 text-decoration-none mb-4 sm:mb-6 group">
                <img
                  src="/assets/images/logo.jpg"
                  alt="Anuppagoundar Tamil Matrimony Logo"
                  className="w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-md object-cover group-hover:scale-105 transition-transform"
                  style={{ border: '1.5px solid rgba(219, 33, 76, 0.35)' }}
                />
                <div>
                  <span className="font-bold block text-text-primary text-base sm:text-lg tracking-wide uppercase leading-tight">
                    ANUPPAGOUNDAR
                  </span>
                  <span className="block text-xs sm:text-sm text-text-primary/60 font-medium">
                    Exclusive Matrimony
                  </span>
                </div>
              </Link>
              <div className="space-y-1">
                <p className="text-xs font-bold text-text-primary/80 uppercase tracking-wider mb-1">
                  Registered Office Address
                </p>
                <p className="text-xs sm:text-sm text-text-primary/70 leading-relaxed font-medium">
                  Reg No: 238/2008 - D-63, First Floor, 11th B Cross Street, Thillai Nagar, Tiruchi - 620 018
                </p>
              </div>
            </div>

            {/* Explore Links */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-4 sm:mb-6">
                Explore
              </h3>
              <div className="w-8 sm:w-[34px] h-[3px] bg-gradient-to-r from-[#8a216b] to-[#f03f16] mb-6 sm:mb-8"></div>
              <ul className="space-y-3 sm:space-y-4">
                <li>
                  <Link
                    to="/matrimony"
                    onClick={handleHomeClick}
                    className="text-sm sm:text-base text-text-primary/70 hover:text-primary-brand transition-colors capitalize text-decoration-none"
                  >
                    Matrimony Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/matrimony/search"
                    onClick={handleSearchClick}
                    className="text-sm sm:text-base text-text-primary/70 hover:text-primary-brand transition-colors capitalize text-decoration-none"
                  >
                    Search Profiles
                  </Link>
                </li>
                <li>
                  <Link
                    to={user ? "/matrimony/plans" : "/matrimony#plans"}
                    onClick={handlePlansClick}
                    className="text-sm sm:text-base text-text-primary/70 hover:text-primary-brand transition-colors capitalize text-decoration-none"
                  >
                    Membership Plans
                  </Link>
                </li>
                <li>
                  <Link
                    to="/matrimony#stories"
                    onClick={handleStoriesClick}
                    className="text-sm sm:text-base text-text-primary/70 hover:text-primary-brand transition-colors capitalize text-decoration-none"
                  >
                    Success Stories
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal Info */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-4 sm:mb-6">
                Legal Info
              </h3>
              <div className="w-8 sm:w-[34px] h-[3px] bg-gradient-to-r from-[#8a216b] to-[#f03f16] mb-6 sm:mb-8"></div>
              <ul className="space-y-3 sm:space-y-4">
                <li><Link to="/privacy" className="text-sm sm:text-base text-text-primary/50 hover:text-primary-brand transition-colors capitalize">Privacy Policy</Link></li>
                <li><Link to="/terms" className="text-sm sm:text-base text-text-primary/50 hover:text-primary-brand transition-colors capitalize">Terms of Use</Link></li>
                <li><Link to="/guidelines" className="text-sm sm:text-base text-text-primary/50 hover:text-primary-brand transition-colors capitalize">Community Guidelines</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold text-text-primary mb-4 sm:mb-6">
                Contact Info
              </h3>
              <div className="w-8 sm:w-[34px] h-[3px] bg-gradient-to-r from-[#8a216b] to-[#f03f16] mb-6 sm:mb-8"></div>
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <p className="text-xs font-bold text-text-primary/80 uppercase tracking-wider mb-1">Phone / WhatsApp</p>
                  <a href="tel:+919791198629" className="text-base sm:text-lg text-text-primary hover:text-primary-brand transition-colors">
                    +91 97911 98629
                  </a>
                </div>
                <div>
                  <p className="text-xs font-bold text-text-primary/80 uppercase tracking-wider mb-1">Email Address</p>
                  <a href="mailto:tnagnsttm@gmail.com" className="text-base sm:text-lg text-text-primary hover:text-primary-brand transition-colors underline">
                    tnagnsttm@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="pt-6 sm:pt-8 border-t border-text-primary/10">
            <div className="flex flex-col sm:flex-row items-center justify-end gap-4 sm:gap-6">
              <div className="flex items-center gap-3 sm:gap-4">
                <span className="text-sm sm:text-base font-semibold text-text-primary/70">
                  Follow Us:
                </span>
                {/* Facebook */}
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all"
                  aria-label="Facebook"
                  title="Facebook"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 fill-current" viewBox="0 0 24 24">
                    <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H7.5v-3H10V9.69c0-2.47 1.47-3.83 3.72-3.83 1.08 0 2.21.19 2.21.19v2.43h-1.24c-1.23 0-1.62.76-1.62 1.54V12h2.74l-.44 3H13.1v6.8c4.56-.93 8-4.96 8-9.8z" />
                  </svg>
                </a>

                {/* Instagram */}
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all"
                  aria-label="Instagram"
                  title="Instagram"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 fill-current" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>

                {/* YouTube */}
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all"
                  aria-label="YouTube"
                  title="YouTube"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 fill-current" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>

                {/* Twitter / X */}
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all"
                  aria-label="Twitter"
                  title="Twitter"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 fill-current" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="w-full bg-[#0f0a19] text-white py-6 sm:py-8 border-t border-white/10 m-0">
        <div className="w-full max-w-[1360px] mx-auto px-4 sm:px-6">
          <p className="text-xs sm:text-sm text-white/60 text-center sm:text-left">
            <span>© 2026 </span>
            <span className="text-white font-semibold">Anuppagoundar Matrimony</span>
            <span>. All Rights Reserved. Built with respect and tech.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;